import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LoginPageLogo from 'app/scripts/components/common/login/logo';
import TextField from '../common/inputs/text-field';
import { LOADING } from '../../models/request-status';
import setSuperOwnerAction from './actions/set-super-owner';
import { connect } from 'react-redux';

const displayName = 'SuperOwner';

class SuperOwner extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      spotId: ''
    };
  }

  handleSpotIdChange(spotId) {
    this.setState({ spotId });
  }

  setSuperOwner() {
    var spotId = this.state.spotId;
    this.context.executeAction(setSuperOwnerAction, { spotId });
  }

  render() {
    var { superAdminStatus } = this.props;
    return (
      <div className="form super-owner-form">
        <div className="form-wrapper">
          <div className="main-content">
            <LoginPageLogo />
            <div className="text-section">
              <span className="title">Super Admin</span>
            </div>
            <div className="fields">
              <TextField
                placeholder="Type spot id"
                onChange={this.handleSpotIdChange.bind(this)}
                value={this.state.spotId}
              />
            </div>
            <button className="continue-button" onClick={this.setSuperOwner.bind(this)}>
              {superAdminStatus === LOADING ? <span className="spinner" /> : 'Continue'}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

SuperOwner.displayName = displayName;

SuperOwner.propTypes = {
  superAdminStatus: PropTypes.string
};

SuperOwner.contextTypes = {
  getStore: PropTypes.func.isRequired,
  executeAction: PropTypes.func.isRequired
};

function mapStateToProps(state) {
  return {
    superAdminStatus: state.auth.superAdmin.status
  };
}

export default connect(mapStateToProps)(SuperOwner);
